import CONF from 'config/conf.singleton';

export const getNcobRedirectUrl = ({ ncobTinyUrl, salonId, isNewNcob }) => {
  if (!ncobTinyUrl) return null;

  if (isNewNcob) {
    return `${CONF.ncobV2BaseUrl}/${salonId}`;
  }

  return ncobTinyUrl;
};
